<template>
  <div>
    <b-tabs content-class="mt-3">
      <b-tab :title="modalHeadTitle" lazy>
        <b-form @submit.stop.prevent="onSubmit">

<!--          <div class="card mb-3" style="max-width: 140px">-->
<!--            <div class="card-header p-2">-->
<!--              Selected Year-->
<!--            </div>-->
<!--            <div class="card-body p-2">-->
<!--              {{ year }}-->
<!--            </div>-->
<!--          </div>-->

          <table class="table table-striped mt-2">
            <thead>
            <tr class="table-head">
              <th></th>
              <th>Monthly</th>
              <th>Yearly</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(head, index) in data" :key="index">
              <input type="hidden" v-model="head.id">
              <input type="hidden" v-model="head.employee_cost_id">
              <td class="align-middle">
                {{ head.name }}
              </td>
              <td>
                <b-form-group :id="`monthly-${head.id}-group`" label="" :label-for="`monthly-${head.id}`"
                              class="m-0 w-50">
                  <b-form-input :id="`monthly-${head.id}`"
                                :name="`monthly-${head.id}`"
                                v-model.number="head.monthly"
                                v-validate="{}"
                                :state="validateState(`monthly-${head.id}`)"
                                :aria-describedby="`monthly-${head.id}-feedback`"
                                data-vv-as="Monthly Cost"></b-form-input>
                  <b-form-invalid-feedback :id="`monthly-${head.id}-feedback`">
                    {{ veeErrors.first(`monthly-${head.id}`) }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </td>
              <td>
                <b-form-group :id="`monthly-${head.id}-group`" label="" :label-for="`monthly-${head.id}`"
                              class="m-0 w-50">
                  <b-form-input :id="`monthly-${head.id}`"
                                :name="`monthly-${head.id}`"
                                v-model.number="head.yearly"
                                v-validate="{ }"
                                :state="validateState(`monthly-${head.id}`)"
                                :aria-describedby="`monthly-${head.id}-feedback`"
                                data-vv-as="Monthly Cost"></b-form-input>
                  <b-form-invalid-feedback :id="`monthly-${head.id}-feedback`">
                    {{ veeErrors.first(`monthly-${head.id}`) }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </td>
            </tr>
            </tbody>
          </table>

          <div class="">
            <b-button type="submit" variant="success">Submit</b-button>
          </div>
        </b-form>
      </b-tab>
      <b-tab v-if="parseInt(type) === 1" title="Annual Overhead Cost" lazy>
        <b-form @submit.stop.prevent="onOverheadSubmit">
<!--          <div class="card mb-3" style="max-width: 140px">-->
<!--            <div class="card-header p-2">-->
<!--              Selected Year-->
<!--            </div>-->
<!--            <div class="card-body p-2">-->
<!--              {{ year }}-->
<!--            </div>-->
<!--          </div>-->
          

          <table class="table table-striped mt-2">
            <thead>
            <tr class="table-head">
              <th>Overhead Monthly</th>
              <th>Overhead Yearly</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <input type="hidden" v-model="overheadData.id">
              <td>
                <b-form-group id="overhead-monthly" label="" label-for="overhead-monthly" class="w-50 m-0">
                  <b-form-input id="overhead-monthly"
                                name="overhead-monthly"
                                v-model="overheadData.monthly"
                                :state="validateState('overhead-monthly')" aria-describedby="overhead-monthly"
                                data-vv-as="Monthly Cost"></b-form-input>
                  <b-form-invalid-feedback id="overhead-monthly-feedback">
                    {{ veeErrors.first("overhead-monthly") }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </td>
              <td>
                <b-form-group id="overhead-yearly" label="" label-for="overhead-yearly" class="w-50 m-0">
                  <b-form-input id="overhead-yearly"
                                name="overhead-yearly"
                                v-model="overheadData.yearly"
                                :state="validateState('overhead-yearly')" aria-describedby="overhead-yearly"
                                data-vv-as="Monthly Cost"></b-form-input>
                  <b-form-invalid-feedback id="overhead-yearly-feedback">
                    {{ veeErrors.first("overhead-yearly") }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </td>
            </tr>
            </tbody>
          </table>

          <!--                <b-row>-->
          <!--                  <input type="hidden" v-model="overheadData.id">-->
          <!--                  <b-col>-->
          <!--                    <b-form-group id="overhead-monthly" label="" label-for="overhead-monthly">-->
          <!--                      <b-form-input id="overhead-monthly"-->
          <!--                                    name="overhead-monthly"-->
          <!--                                    v-model="overheadData.monthly"-->
          <!--                                    :state="validateState('overhead-monthly')" aria-describedby="overhead-monthly"-->
          <!--                                    data-vv-as="Monthly Cost"></b-form-input>-->
          <!--                      <b-form-invalid-feedback id="overhead-monthly-feedback">-->
          <!--                        {{ veeErrors.first("overhead-monthly") }}-->
          <!--                      </b-form-invalid-feedback>-->
          <!--                    </b-form-group>-->
          <!--                  </b-col>-->
          <!--                  <b-col>-->
          <!--                    <b-form-group id="overhead-yearly" label="" label-for="overhead-yearly">-->
          <!--                      <b-form-input id="overhead-yearly"-->
          <!--                                    name="overhead-yearly"-->
          <!--                                    v-model="overheadData.yearly"-->
          <!--                                    :state="validateState('overhead-yearly')" aria-describedby="overhead-yearly"-->
          <!--                                    data-vv-as="Monthly Cost"></b-form-input>-->
          <!--                      <b-form-invalid-feedback id="overhead-yearly-feedback">-->
          <!--                        {{ veeErrors.first("overhead-yearly") }}-->
          <!--                      </b-form-invalid-feedback>-->
          <!--                    </b-form-group>-->
          <!--                  </b-col>-->
          <!--                </b-row>-->
          <div class="">
            <b-button type="submit" variant="success">Submit</b-button>
          </div>
        </b-form>
      </b-tab>
    </b-tabs>
  </div>
</template>
<script>
import moment from "moment";
import {defaultsDeep} from "lodash/object";

export default {
  props: [
    'employeeID', 'year', 'type'
  ],
  mounted() {
    // this.permission = this.$acl['leave-type'];
  },
  data() {
    let sortOrders = {};
    let columns = [
      {label: 'Name', name: 'name', sort: true},
      {label: 'Status', name: 'status'},
    ];
    columns.forEach((column) => {
      sortOrders[column.name] = -1;
    });


    let modalHeadTitle = parseInt(this.type) === 1 ? 'Annual Year Statement' : 'Compensatory Statement';

    return {
      blankMsg: 'Fetching data..',

      showOverlay: false,
      data: [],
      overheadData: {},

      status: [
        {value: "0", text: "Disabled"},
        {value: "1", text: "Enable"},
      ],


      years: [
        {text: '2019', value: '2019'},
        {text: '2020', value: '2020'},
        {text: '2021', value: '2021'},
        {text: '2022', value: '2022'},
        {text: '2023', value: '2023'},
        {text: '2024', value: '2024'},
        {text: '2025', value: '2025'},
        {text: '2026', value: '2026'},
      ],

      modalHeadTitle: modalHeadTitle,
    }
  },
  methods: {
    exportEmployeeData() {
      this.$bvModal.show("bv-modal-employee-list");
    },
    resetForm() {
      this.$nextTick(() => {
        this.$validator.reset();
      });
    },
    getCostMapping() {
      if (!this.checkNet()) return false;

      this.data = [];
      let currentObj = this;

      let formData = {
        employee_id: this.employeeID,
        year: this.year,
        type: this.type,
      }

      axios.post('get-employee-cost-mapping', formData).then((response) => {
        response.data.fieldData.forEach((item, i) => {
          this.data.push({
            id: item.mapping_id,
            employee_cost_id: item.employee_cost_id,
            name: item.name,
            employee_id: currentObj.employeeID,
            monthly: item.monthly,
            yearly: item.yearly
          });
        });

        if (response.data.overheadData !== null) {
          currentObj.overheadData = response.data.overheadData;
        }
      }).catch((error) => {
        currentObj.serverError(error)
      })
    },
    onSubmit(e) {
      // if (!this.checkNet()) return false;
      this.$validator.validateAll().then(result => {
        if (!result) {
          return;
        }
        this.showOverlay = true;

        e.preventDefault();
        let currentObj = this;

        /*let fieldValue = 0;
        this.data.forEach((value) => {
          if (!isNaN(parseInt(value.monthly)) && parseInt(value.monthly) > 0) {
            fieldValue = 1;
          }
          if (!isNaN(parseInt(value.yearly)) && parseInt(value.yearly) > 0) {
            fieldValue = 1;
          }
        })

        if (fieldValue === 0) {
          let msg = "Please add valid value on at least one field."
          this.$bvToast.toast(msg, {
            title: `Error!`,
            variant: 'danger',
            solid: true,
            toaster: 'b-toaster-top-right'
          });

          return;
        }*/

        let url = 'cost-mapping';
        let formData = {
          employee_id: this.employeeID,
          year: this.year,
          main: this.data,
          type: this.type,
        }
        axios.post(url, formData)
            .then(function (response) {

              this.showOverlay = false;
              this.resetForm();
              // this.getCostMapping();

              this.$emit("close-cost-mapping-modal", "")

            }.bind(this))
            .catch(function (error) {
              // currentObj.showOverlay = false;
              currentObj.serverError(error);
            });
      });
    },
    onOverheadSubmit(e) {
      this.$validator.validateAll().then(result => {
        if (!result) {
          return;
        }
        this.showOverlay = true;

        e.preventDefault();
        let currentObj = this;

        let url = 'cost-overhead-mapping';

        let fieldValue = 0;
        if (!isNaN(parseInt(this.overheadData.monthly)) && !isNaN(parseInt(this.overheadData.yearly))) {
          if (parseInt(this.overheadData.monthly) > 0 && parseInt(this.overheadData.yearly) > 0) {
            fieldValue = 1;
          }
        }

        if (fieldValue === 0) {
          let msg = "Please add valid value for both monthly and yearly for Overhead Cost."
          this.$bvToast.toast(msg, {
            title: `Error!`,
            variant: 'danger',
            solid: true,
            toaster: 'b-toaster-top-right'
          });

          return;
        }


        let overheadFromData = {
          year: this.year,
          main: this.overheadData,
          valu: 'asss',
        }

        axios.post(url, overheadFromData)
            .then(function (response) {
              this.showOverlay = false;
              this.$emit("close-cost-mapping-modal", "")
            }.bind(this))
            .catch(function (error) {
              currentObj.showOverlay = false;
              currentObj.serverError(error);
            });
      });
    }
  },
  created: function () {
    this.getCostMapping();
  },
}
</script>
  
